import { CommonState } from 'embed/reducers'
import { Product } from 'even-ts-static'

export const loadingSelector = (state: CommonState, product: Product): boolean =>
  (state.loading[product]?.loading ?? 0) > 0

export const loadingErrorSelector = (state: CommonState, product: Product): boolean => !!state.loading[product]?.error

export const loadingStartTimeSelector = (state: CommonState, product: Product): Date | undefined =>
  state.loading[product]?.startTime
